import { useDisplayPriorityContext } from 'modules/placements/context/DisplayPriorityContext';
import { Skeleton } from 'ui/skeleton';
import {
  DisplayPriorityEditContainer,
  DisplayPriorityOrderFrame,
  StyledCaption,
} from './styled/DisplayPriorityTakeover.styled';
import { DisplayPriorityOrder } from './DisplayPriorityOrder';

type DisplayPriorityEditProps = {
  currentCampaignId?: number;
};

export const DisplayPriorityEdit = ({ currentCampaignId }: DisplayPriorityEditProps) => {
  const { isLoadingCampaignsForPlacement } = useDisplayPriorityContext();
  return (
    <DisplayPriorityEditContainer data-test="display-priority">
      <StyledCaption>Highest display priority</StyledCaption>
      <DisplayPriorityOrderFrame>
        {isLoadingCampaignsForPlacement ? (
          <Skeleton height={90} />
        ) : (
          <DisplayPriorityOrder currentCampaignId={currentCampaignId} />
        )}
      </DisplayPriorityOrderFrame>
      <StyledCaption>Lowest display priority</StyledCaption>
    </DisplayPriorityEditContainer>
  );
};
